import { useNetworkStatus } from "@shared/hooks/useNetworkStatus";
import clsx from "clsx";
import { Outlet } from "react-router-dom";

export function OnboardingLayout() {
  const { isOnline, isSlowConnection } = useNetworkStatus();

  return (
    <div className={clsx("fixed inset-0", "bg-lavender-400")}>
      {!isOnline && (
        <div
          className="bg-amber-100 border-b border-amber-200 px-4 py-2 text-center text-sm text-amber-900"
          data-testid="onboarding-offline-banner"
        >
          You're offline. Changes will save when connection returns.
        </div>
      )}
      {isOnline && isSlowConnection && (
        <div
          className="bg-amber-100 border-b border-amber-200 px-4 py-2 text-center text-sm text-amber-900"
          data-testid="onboarding-slow-connection-banner"
        >
          Connection looks weak. Photo upload may take longer.
        </div>
      )}
      <main className="w-full h-full overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
